module.exports = __webpack_public_path__ + "517dfcacf29638f9fe27a2a2fb961f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/wechat-qr.png
// module id = 651
// module chunks = 47